const MODAL_OPEN = 'MODAL_OPEN';
const MODAL_CLOSE = 'MODAL_CLOSE';
const MODAL_LOADING = 'MODAL_LOADING';

export {
  MODAL_OPEN,
  MODAL_CLOSE,
  MODAL_LOADING,
};
